export default __webpack_public_path__ + "static/XT307632-010090e034edb274ea600b32c7d52732.jpg";